/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivDashboardLifetimeSummaryViewModelGen,
  MrfiktivDashboardPeriodHeroViewModelGen,
  MrfiktivDashboardPeriodKpiTilesViewModelGen,
  MrfiktivDashboardTimeSeriesViewModelGen,
  MrfiktivDashboardTopRulesViewModelGen,
  MrfiktivDashboardUserComparisonViewModelGen,
  MrfiktivDashboardUserDetailViewModelGen,
  MrfiktivDashboardUserRankingViewModelGen,
  MrfiktivDocumentIdsAiDtoGen,
  MrfiktivDocumentRuleCheckControllerGetParamsGen,
  MrfiktivDocumentRuleCheckControllerGetUsageParamsGen,
  MrfiktivDocumentRuleCheckDashboardControllerGetTimeSeriesParamsGen,
  MrfiktivDocumentRuleCheckDashboardControllerGetTopRulesParamsGen,
  MrfiktivDocumentRuleCheckDashboardControllerGetUserComparisonParamsGen,
  MrfiktivDocumentRuleCheckDashboardControllerGetUserDetailParamsGen,
  MrfiktivDocumentRuleCheckDashboardControllerGetUsersParamsGen,
  MrfiktivDocumentRuleCheckUsageViewModelGen,
  MrfiktivDocumentRuleCheckViewModelGen,
  MrfiktivPageViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class DocumentRuleCheck<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckControllerAnalysesDocumentRulesForImages
   * @summary (Document rule check - CREATE) Schedules a document rule check
   * @request POST:/partner/{partnerId}/document-rule-check
   * @secure
   * @response `201` `MrfiktivDocumentRuleCheckViewModelGen` The Document Rule check viewmodel
   */
  documentRuleCheckControllerAnalysesDocumentRulesForImages = (
    partnerId: string,
    data: MrfiktivDocumentIdsAiDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDocumentRuleCheckViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckControllerGet
   * @summary (Document rule check - READ) Get all document rule checks
   * @request GET:/partner/{partnerId}/document-rule-check
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivDocumentRuleCheckViewModelGen)[] })`
   */
  documentRuleCheckControllerGet = (
    { partnerId, ...query }: MrfiktivDocumentRuleCheckControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivDocumentRuleCheckViewModelGen[] }, any>({
      path: `/partner/${partnerId}/document-rule-check`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckControllerGetUsage
   * @summary (Document rule check - READ) Get usage totals for a partner in a period
   * @request GET:/partner/{partnerId}/document-rule-check/usage
   * @secure
   * @response `200` `MrfiktivDocumentRuleCheckUsageViewModelGen` Usage totals for the partner in the requested period
   */
  documentRuleCheckControllerGetUsage = (
    { partnerId, ...query }: MrfiktivDocumentRuleCheckControllerGetUsageParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDocumentRuleCheckUsageViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/usage`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckControllerGetOne
   * @summary (Document rule checks - READ) Get a document rule check
   * @request GET:/partner/{partnerId}/document-rule-check/{documentRuleCheckId}
   * @secure
   * @response `200` `MrfiktivDocumentRuleCheckViewModelGen` The document rule check
   */
  documentRuleCheckControllerGetOne = (partnerId: string, documentRuleCheckId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDocumentRuleCheckViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/${documentRuleCheckId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckControllerDelete
   * @summary (ADMIN) Delete a document rule check
   * @request DELETE:/partner/{partnerId}/document-rule-check/{documentRuleCheckId}
   * @secure
   * @response `200` `MrfiktivDocumentRuleCheckViewModelGen` The deleted document rule check
   */
  documentRuleCheckControllerDelete = (partnerId: string, documentRuleCheckId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDocumentRuleCheckViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/${documentRuleCheckId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckControllerClose
   * @summary (Document rule check - UPDATE) Close a document rule check
   * @request PATCH:/partner/{partnerId}/document-rule-check/{documentRuleCheckId}/close
   * @secure
   * @response `200` `MrfiktivDocumentRuleCheckViewModelGen` The closed document rule check
   */
  documentRuleCheckControllerClose = (partnerId: string, documentRuleCheckId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDocumentRuleCheckViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/${documentRuleCheckId}/close`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckControllerReopen
   * @summary (Document rule check - UPDATE) Reopen a closed document rule check
   * @request PATCH:/partner/{partnerId}/document-rule-check/{documentRuleCheckId}/reopen
   * @secure
   * @response `200` `MrfiktivDocumentRuleCheckViewModelGen` The reopened document rule check
   */
  documentRuleCheckControllerReopen = (partnerId: string, documentRuleCheckId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDocumentRuleCheckViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/${documentRuleCheckId}/reopen`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckDashboardControllerGetLifetimeSummary
   * @summary (Document rule check dashboard - READ) Lifetime aggregate over a partner's completed checks
   * @request GET:/partner/{partnerId}/document-rule-check/analytics/lifetime-summary
   * @secure
   * @response `200` `MrfiktivDashboardLifetimeSummaryViewModelGen` Lifetime summary viewmodel
   */
  documentRuleCheckDashboardControllerGetLifetimeSummary = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDashboardLifetimeSummaryViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/analytics/lifetime-summary`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckDashboardControllerGetPeriodHero
   * @summary (Document rule check dashboard - READ) 30-day hero aggregate for a partner
   * @request GET:/partner/{partnerId}/document-rule-check/analytics/period-hero
   * @secure
   * @response `200` `MrfiktivDashboardPeriodHeroViewModelGen` Period hero viewmodel
   */
  documentRuleCheckDashboardControllerGetPeriodHero = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDashboardPeriodHeroViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/analytics/period-hero`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckDashboardControllerGetPeriodKpiTiles
   * @summary (Document rule check dashboard - READ) 30-day KPI tiles with deltas and sparklines
   * @request GET:/partner/{partnerId}/document-rule-check/analytics/period-kpi-tiles
   * @secure
   * @response `200` `MrfiktivDashboardPeriodKpiTilesViewModelGen` Period KPI tiles viewmodel
   */
  documentRuleCheckDashboardControllerGetPeriodKpiTiles = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDashboardPeriodKpiTilesViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/analytics/period-kpi-tiles`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckDashboardControllerGetTimeSeries
   * @summary (Document rule check dashboard - READ) Bucketed time series for a partner
   * @request GET:/partner/{partnerId}/document-rule-check/analytics/time-series
   * @secure
   * @response `200` `MrfiktivDashboardTimeSeriesViewModelGen` Time series viewmodel
   */
  documentRuleCheckDashboardControllerGetTimeSeries = (
    { partnerId, ...query }: MrfiktivDocumentRuleCheckDashboardControllerGetTimeSeriesParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDashboardTimeSeriesViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/analytics/time-series`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckDashboardControllerGetTopRules
   * @summary (Document rule check dashboard - READ) Top rules by aggregated additional revenue
   * @request GET:/partner/{partnerId}/document-rule-check/analytics/top-rules
   * @secure
   * @response `200` `MrfiktivDashboardTopRulesViewModelGen` Top rules viewmodel
   */
  documentRuleCheckDashboardControllerGetTopRules = (
    { partnerId, ...query }: MrfiktivDocumentRuleCheckDashboardControllerGetTopRulesParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDashboardTopRulesViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/analytics/top-rules`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckDashboardControllerGetUsers
   * @summary (Document rule check dashboard - READ) Per-employee ranking with team average
   * @request GET:/partner/{partnerId}/document-rule-check/analytics/users
   * @secure
   * @response `200` `MrfiktivDashboardUserRankingViewModelGen` Employee ranking viewmodel
   */
  documentRuleCheckDashboardControllerGetUsers = (
    { partnerId, ...query }: MrfiktivDocumentRuleCheckDashboardControllerGetUsersParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDashboardUserRankingViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/analytics/users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckDashboardControllerGetUserComparison
   * @summary (Document rule check dashboard - READ) Compare up to three employees
   * @request GET:/partner/{partnerId}/document-rule-check/analytics/users/comparison
   * @secure
   * @response `200` `MrfiktivDashboardUserComparisonViewModelGen` Employee comparison viewmodel
   */
  documentRuleCheckDashboardControllerGetUserComparison = (
    { partnerId, ...query }: MrfiktivDocumentRuleCheckDashboardControllerGetUserComparisonParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDashboardUserComparisonViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/analytics/users/comparison`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckDashboardControllerGetUserDetail
   * @summary (Document rule check dashboard - READ) Per-employee detail with tiles, series and top rules
   * @request GET:/partner/{partnerId}/document-rule-check/analytics/users/{userId}
   * @secure
   * @response `200` `MrfiktivDashboardUserDetailViewModelGen` Employee detail viewmodel
   */
  documentRuleCheckDashboardControllerGetUserDetail = (
    { partnerId, userId, ...query }: MrfiktivDocumentRuleCheckDashboardControllerGetUserDetailParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDashboardUserDetailViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/analytics/users/${userId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
}
